// shared/UIParts/InteractiveIcon.tsx
import React from "react";
import { Box, Tooltip } from "@mui/material";

interface InteractiveIconProps {
  icon: React.ReactNode;
  tooltip: string;
  active: boolean;
  onToggle: (newValue: boolean) => void;
  color?: string; // ⬅️ תוספת חדשה
}

const InteractiveIcon: React.FC<InteractiveIconProps> = ({
  icon,
  tooltip,
  active,
  onToggle,
  color,
}) => {
  const handleClick = (event: React.MouseEvent) => {
    event.stopPropagation(); // ✅ מונע פתיחת המגירה
    onToggle(!active);
  };

  return (
    <Tooltip title={tooltip}>
      <Box
        component="span"
        onClick={handleClick}
        sx={{
          cursor: "pointer",
          opacity: active ? 1 : 0.4,
          transition: "opacity 0.2s",
          fontSize: "1.5rem",
          display: "flex",
          alignItems: "center",
          color: color || "inherit", // ⬅️ שימוש בצבע
        }}
      >
        {icon}
      </Box>
    </Tooltip>
  );
};

export default InteractiveIcon;
